import { IAutocompleteItem } from 'ui-components/dist/Autocomplete';

import { ILocation } from './types';

export const mapLocationToAutocompleteItem = (
  location?: ILocation,
): IAutocompleteItem | null => {
  if (!location?.id || !location?.city?.length || !location?.country?.length)
    return null;

  return {
    id: location.id,
    label: `${location.city}, ${location.country}`,
    value: location.id,
  };
};
